import { CdkPortalOutlet } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChip, MatChipSet } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { DatepickerWeekNumberDirective } from '../../directives/datepicker-week-number.directive';
import { DecimalInputDirective } from '../../directives/decimal-input.directive';
import { GenericModule } from '../../generic/generic.module';
import { HourtypeIconPipe } from '../../pipes/hourtype-icon.pipe';
import { HourtypePipe } from '../../pipes/hourtype.pipe';
import { PhoneNumberPipe } from '../../pipes/phone-number.pipe';
import { FieldErrorComponent } from '../field-error/field-error.component';
import { FieldInputComponent } from './field-input.component';
import { BaseDateTimeInputComponent } from './fields/base-date-time-input/base-date-time-input.component';
import { CheckboxInputComponent } from './fields/checkbox-input/checkbox-input.component';
import { CustomerInputComponent } from './fields/customer-input/customer-input.component';
import { DateInputComponent } from './fields/date-input/date-input.component';
import { DateTimeInputComponent } from './fields/date-time-input/date-time-input.component';
import { EntityInputComponent } from './fields/entity-input/entity-input.component';
import { HiringInputComponent } from './fields/hiring-input/hiring-input.component';
import { InputComponent } from './fields/input/input.component';
import { LabelComponent } from './fields/label/label.component';
import { LocationInputComponent } from './fields/location-input/location-input.component';
import { NumberInputComponent } from './fields/number-input/number-input.component';
import { PersonInputComponent } from './fields/person-input/person-input.component';
import { ProgressDatesComponent } from './fields/progress-dates/progress-dates.component';
import { ProjectInputComponent } from './fields/project-input/project-input.component';
import { RadioInputComponent } from './fields/radio-input/radio-input.component';
import { SelectInputComponent } from './fields/select-input/select-input.component';
import { StatusInputComponent } from './fields/status-input/status-input.component';
import { TextInputComponent } from './fields/text-input/text-input.component';
import { TextareaInputComponent } from './fields/textarea-input/textarea-input.component';
import { TimeInputComponent } from './fields/time-input/time-input.component';
import { UserInputComponent } from './fields/user-input/user-input.component';
import { UserWithLeaveInputComponent } from './fields/user-with-leave-input/user-with-leave-input.component';

const FIELD_INPUT_COMPONENTS = [
    FieldInputComponent,
    InputComponent,
    NumberInputComponent,
    LabelComponent,
    ProgressDatesComponent,
    TextInputComponent,
    CheckboxInputComponent,
    TextareaInputComponent,
    DateTimeInputComponent,
    DateInputComponent,
    SelectInputComponent,
    StatusInputComponent,
    UserInputComponent,
    UserWithLeaveInputComponent,
    TimeInputComponent,
    RadioInputComponent,
    ProjectInputComponent,
    LocationInputComponent,
    EntityInputComponent,
    BaseDateTimeInputComponent,
    DecimalInputDirective,
    FieldErrorComponent,
    HiringInputComponent,
    CustomerInputComponent,
    PersonInputComponent,
];

@NgModule({
    declarations: FIELD_INPUT_COMPONENTS,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatRadioModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatChip,
        MatChipSet,
        NgSelectModule,
        MatProgressBarModule,
        CdkPortalOutlet,
        GenericModule,
        HourtypeIconPipe,
        HourtypePipe,
        PhoneNumberPipe,
        DatepickerWeekNumberDirective,
    ],
    exports: [FieldInputComponent, DecimalInputDirective, FieldErrorComponent, HourtypeIconPipe, HourtypePipe],
})
export class FieldInputModule {}
